import { render, staticRenderFns } from "./PaymentCompletePage.vue?vue&type=template&id=dc080736&scoped=true"
import script from "./PaymentCompletePage.vue?vue&type=script&lang=ts"
export * from "./PaymentCompletePage.vue?vue&type=script&lang=ts"
import style0 from "./PaymentCompletePage.vue?vue&type=style&index=0&id=dc080736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc080736",
  null
  
)

export default component.exports